import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { ListContextRenderer } from '../../../../vtex-apps/list-context/ListContextRenderer/default';
import { StoreImageList } from '../../../../vtex-apps/store-image-list/StoreImageList/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function BannerSectionGroup() {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		componentGroup: 'BannerSectionGroup',
		variables,
		props: VisibilityLayout({ mzTitle: 'MZ | Seção de Banners (On/Off)' }).props,
		childrenComponents: [
			FlexLayoutRow(
				{ blockClass: 'bsg-3__flex-row', marginTop: 9, marginBottom: 9, mzTitle: 'MZ | Mosaico - Banners' },
				[
					StoreImageList(
						{
							preload: true,
							images: [
								{
									image: 'https://hefesto-upload-images.s3.amazonaws.com/1683045129166-bannergroup1-hefestO-2.png',
									mobileImage:
										'https://hefesto-upload-images.s3.amazonaws.com/1683045129166-bannergroup1-hefestO-2.png',
									description: 'Imagem',
								},
								{
									image: 'https://hefesto-upload-images.s3.amazonaws.com/1683045154605-bannergroup1-hefesto--1-.png',
									mobileImage:
										'https://hefesto-upload-images.s3.amazonaws.com/1683045154605-bannergroup1-hefesto--1-.png',
									description: 'Imagem',
								},
								{
									image: 'https://hefesto-upload-images.s3.amazonaws.com/1683045154605-bannergroup1-hefesto--1-.png',
									mobileImage:
										'https://hefesto-upload-images.s3.amazonaws.com/1683045154605-bannergroup1-hefesto--1-.png',
								},
							],
						},
						[
							ListContextRenderer({
								listElement: 'div',
								itemElement: 'div',
								blockClass: 'bsg-3__flex-row',
							}),
						],
					),
				],
			),
		],
	};
}

const variables = [
	//background color
	{ type: 'color', list: [{ from: '--transparent', to: '--bsg-3-bg-color', name: 'Background' }] },
	{ type: 'spacing', list: [{ from: '--spacing-xs', to: '--bsg-3-img-gap', name: 'Gap' }] },
	{ type: 'borderRadius', list: [{ from: '--border-radius-none', to: '--bsg-3-img-br', name: 'Image' }] },
];
